module.exports = __webpack_public_path__ + "static/media/SF-10-A (1).c8e44af5.mp3";